var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.3,
    fill: "#F1F1F1",
    fillOpacity: 0.2,
    stroke: "#F1F1F1",
    strokeWidth: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 24.6666C16.3681 24.6666 16.6666 24.3682 16.6666 24C16.6666 23.6318 16.3681 23.3333 15.9999 23.3333C15.6317 23.3333 15.3333 23.6318 15.3333 24C15.3333 24.3682 15.6317 24.6666 15.9999 24.6666Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 24.6666C23.7016 24.6666 24.0001 24.3682 24.0001 24C24.0001 23.6318 23.7016 23.3333 23.3334 23.3333C22.9652 23.3333 22.6667 23.6318 22.6667 24C22.6667 24.3682 22.9652 24.6666 23.3334 24.6666Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 14L15.1201 19.5934C15.181 19.9003 15.348 20.176 15.5918 20.3722C15.8355 20.5684 16.1405 20.6727 16.4534 20.6667H22.9334C23.2463 20.6727 23.5513 20.5684 23.795 20.3722C24.0388 20.176 24.2058 19.9003 24.2667 19.5934L25.3334 14H14.0001Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10.6667H13.3334L15.1201 19.5934M15.1201 19.5934C15.181 19.9003 15.348 20.176 15.5918 20.3722C15.8355 20.5684 16.1405 20.6727 16.4534 20.6667H22.9334C23.2463 20.6727 23.5513 20.5684 23.795 20.3722C24.0388 20.176 24.2058 19.9003 24.2667 19.5934L25.3334 14H14.0001L15.1201 19.5934Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.ada23f22ec75471ed76bf7d3c1ff4cf5.svg";
export { ForwardRef as ReactComponent };